import script from "./GestionAreasView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GestionAreasView.vue?vue&type=script&lang=ts&setup=true"

import "./GestionAreasView.vue?vue&type=style&index=0&id=5533090d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5533090d"]])

export default __exports__